import { render } from "./MeetingCard.vue?vue&type=template&id=4a4d2048&scoped=true"
import script from "./MeetingCard.vue?vue&type=script&lang=js"
export * from "./MeetingCard.vue?vue&type=script&lang=js"

import "./MeetingCard.vue?vue&type=style&index=0&id=4a4d2048&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a4d2048"]])

export default __exports__